import type { U2000TableColumn } from "../../../../../../u2000Core/components/tables/basic/U2000BasicTableList";
import type { U2000GridStateHandlers } from "../../../../../../u2000Core/reducer/formReducer/U2000GridStateHandlers";

/**
 * Initialise la grille détail (U2000DetailTable) : colonnes visibles + tri par défaut.
 * Sans `setSelectedFields`, seule la colonne `id` (checkbox) s’affiche.
 */
export function u3121InitBillingSummaryDetailGrid<T extends Record<string, unknown>>(
  gridStateHandlers: U2000GridStateHandlers<T>,
  columns: U2000TableColumn[],
  data: T[],
): void {
  const visibleColumns = columns.filter((col) => col.name !== "id");
  gridStateHandlers.setColumns(visibleColumns);
  gridStateHandlers.setSelectedFields(
    visibleColumns.filter((col) => col.isDefaultColumn !== false).map((col) => col.name),
  );
  const defaultSortCol = visibleColumns.find((col) => col.isDefaultSortedColumn);
  gridStateHandlers.setSelectedSortedFields(
    defaultSortCol ? [{ name: defaultSortCol.name, sortOrder: defaultSortCol.defaultSortOrder ?? "ASC" }] : [],
  );
  gridStateHandlers.setData(data);
  gridStateHandlers.setTotalRows(data.length);
}
